export type KoreanUniversityType = 'KOREAN_DEPARTMENT' | 'SECOND_FOREIGN_LANGUAGE'

export interface IKoreanUniversity {
  universityId: number
  regionCode: number
  regionName: string
  universityNameUz: string
  universityNameRu: string
  universityNameKo: string
  type: KoreanUniversityType | string
  typeName: string
}

export type KoreanUniversityPayload = {
  regionCode: number
  universityNameUz: string
  universityNameRu: string
  universityNameKo: string
  type: KoreanUniversityType
}

const isEnvelope = (raw: unknown): raw is { success: boolean; data: unknown } =>
  !!raw && typeof raw === 'object' && 'success' in raw && 'data' in raw

export function normalizeKoreanUniversitiesList(raw: unknown): IKoreanUniversity[] {
  if (Array.isArray(raw)) {
    return raw as IKoreanUniversity[]
  }
  if (isEnvelope(raw) && Array.isArray(raw.data)) {
    return raw.data as IKoreanUniversity[]
  }
  return []
}
